module.exports = __webpack_public_path__ + "img/race_320.27bd9037.png";